import React, { useContext } from "react";
import { useState, useEffect, useRef } from "react";
import "../../../Tabels/Tabels.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";
// *******************toster****************************
import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModelSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import JoditEditor from "jodit-react";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import Select from "react-select";
import Header from "../../../Header/Header";
library.add(fas);

const EditOffCanvance = () => {
  const { postData, getData, Select2Data, getDimension, IMG_URL } = useContext(Context);
  const [blogCategory, setBlogCategory] = useState([]);

  const { id } = useParams();

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/masters/ed-tech/blog/blogs/${id}`);
    reset(response?.data);
  };

  const GetAllBlogCategory = async () => {
    const response = await getData("/allblogcategory");

    if (response?.success) {
      setBlogCategory(await Select2Data(response?.data, "blog_category_id"));
    }
  };

  useEffect(() => {
    GetAllBlogCategory();
    GetEditData();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    reset,
    watch,
    setValue,
    control,
  } = useForm();

  const imageFile1 = watch("heading_image");
  const imageFile2 = watch("banner_image");
  const conclusionValue = watch("conclusion");
  const introductionValue = watch("introduction");
  const detailsValue = watch("details");


  const navigate = useNavigate();
  const onSubmit = async (data) => {
    try {
      console.log("Form data:", data);
      const fromData = new FormData();
      fromData.append("blog_category_id", data?.blog_category_id?.value);
      fromData.append("name", data?.name);
      fromData.append("url", data?.url);
      fromData.append("introduction", data?.introduction);
      fromData.append("conclusion", data?.conclusion);
      fromData.append("details", data?.details);
      fromData.append("sub_heading", data?.sub_heading);
      if (typeof data?.heading_image !== "string") {
        fromData.append("heading_image", data?.heading_image[0]);
      }
      if (typeof data?.banner_image !== "string") {
        fromData.append("banner_image", data?.banner_image[0]);
      }
      fromData.append("meta_title", data?.meta_title);
      fromData.append("meta_description", data?.meta_description);
      fromData.append("keywords", data?.keyword);
      fromData.append("schema", data?.schema);
      fromData.append("og_title", data?.og_title);
      fromData.append("og_description", data?.og_description);
      fromData.append("twitter_title", data?.twitter_title);
      fromData.append("twitter_description", data?.twitter_description);

      fromData.append("alt_cta", data?.alt_cta);
      fromData.append("alt_heading", data?.alt_heading);
      const response = await postData(
        `/masters/ed-tech/blog/blogs/${id}`,
        fromData
      );
      console.log(response);
      if (response?.success) {
        navigate("/masters/ed-tech/blog/blogs");
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="main-advancedashboard blog_addition_div">
        <Header title={"Edit Blog"} link={"/masters/ed-tech/blog/blogs"} />
        <Link to="/masters/ed-tech/blog/blogs">
          <Button className="btn btn-primary mb-3 ms-5" style={{ position: "fixed" }}>Back to Blogs</Button>
        </Link>
        <section className="AdvanceDashboard mt-5">


          <div className="row">
            <div className="col-lg-11 m-auto">
              <Form
                onSubmit={handleSubmit(onSubmit)}
                role="form"
                className="countryclass"
              >
                <Row>
                  {/* Left side: Title and Image Upload */}
                  <Col lg={12}>
                    <div className="main-form-section mt-3">
                      <Row className="row justify-content-center mb-2">
                        <Form.Label>Blog Category</Form.Label>

                        <Controller
                          name="blog_category_id"
                          {...register("blog_category_id", {
                            required: "Category is required",
                          })}
                          control={control}
                          render={({ field }) => (
                            <div style={{ width: "300px" }}>
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,

                                    borderColor: errors.blog_category_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={blogCategory}
                              />
                            </div>
                          )}
                        />


                        {errors.country_id && (
                          <span className="text-danger">
                            {errors.country_id.message}
                          </span>
                        )}
                      </Row>
                    </div>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">Heading</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={9}>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.name,
                              })}
                              type="text"
                              {...register("name", {
                                required: "Title is required",
                              })}
                              placeholder="Title"
                            />
                          </Form.Group>
                          {errors.name && (
                            <span className="text-danger">
                              {errors.name.message}
                            </span>
                          )}
                        </Col>
                      </Row>
                    </div>
                     <div className="main-form-section mt-3">
                                          <Form.Label className="text-center">URL</Form.Label>
                                          <Row className="justify-content-center">
                                            <Col sm={9}>
                                              <Form.Group>
                                                <Form.Control
                                                  className={classNames("", {
                                                    "is-invalid": errors?.url,
                                                  })}
                                                  type="text"
                                                  {...register("url", {
                                                    required: "URL is required",
                                                  })}
                                                  placeholder="URL"
                                                />
                                              </Form.Group>
                                              {errors.url && (
                                                <span className="text-danger">
                                                  {errors.url.message}
                                                </span>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">Heading Image</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={9}>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.heading_image,
                              })}
                              type="file"
                              {...register("heading_image", {
                                // required: "Image is required",
                                validate: async (value) => {
                                  if (typeof value !== "string") {
                                    const fileTypes = ["jpg", "png", "jpeg"];
                                    const fileType = value[0].name?.split(".")[1];

                                    if (!fileTypes.includes(fileType)) {
                                      // // return `please upload a valid file format. (${fileTypes})`;
                                    }

                                    const sizes = await getDimension(value[0]);
                                    if (sizes.width !== 230 && sizes.height !== 230) {
                                      // // return "Image width and height must be 230px and 230px";
                                    }

                                    // const fileSize = Math.round(value[0].size / 1024);
                                    // if (fileSize > 500) {
                                    //   // return "file size must be lower than 500kb";
                                    // }
                                  }
                                }
                              })}
                              accept=".jpg, .jpeg, .png"
                            />
                          </Form.Group>
                          {errors.heading_image && (
                            <span className="text-danger">
                              {errors.heading_image.message}
                            </span>
                          )}
                        </Col>
                      </Row>
                      <div className="main-form-section mt-3">
                        <Form.Label className="text-center">Heading Image</Form.Label>
                        <Row className="justify-content-center">
                          <Col sm={9}>
                            {typeof getValues("heading_image") == "string" ? (
                              <div className="image-preview-container">
                                <img
                                  src={IMG_URL + getValues("heading_image")}
                                  alt="Preview"
                                  className="image-preview"
                                  style={{ width: "324px", height: "99px" }}
                                />
                              </div>
                            ) : (
                              imageFile1 &&
                              imageFile1?.length > 0 && (
                                <div className="image-preview-container">
                                  <img
                                    // src={URL.createObjectURL(getValues("image")[0])}
                                    src={URL?.createObjectURL(imageFile1[0])}
                                    alt="Preview"
                                    className="image-preview"
                                    style={{ width: "324px", height: "99px" }}
                                  />
                                </div>
                              )
                            )}
                          </Col>
                        </Row>
                      </div>
                    </div>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">Alt Heading</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={9}>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.alt_heading,
                              })}
                              type="text"
                              {...register("alt_heading", {
                                // required: "Alt Heading is required",
                              })}
                              placeholder="Alt Heading"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>

                  </Col>
                  <Col lg={12}>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">Sub Heading</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={12}>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.sub_heading,
                              })}
                              type="text"
                              as="textarea"
                              rows={3}
                              {...register("sub_heading", {
                                required: "Sub Heading is required",
                              })}
                              placeholder="Sub Heading"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">introduction</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={12}>
                          <JoditEditor
                            value={introductionValue}
                            onChange={(value) => setValue("introduction", value)}
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">CTA Image</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={9}>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.banner_image,
                              })}
                              type="file"
                              {...register("banner_image", {
                                // required: "banner_image is required",
                                validate: async (value) => {
                                  if (typeof value !== "string") {
                                    const fileTypes = ["jpg", "png", "jpeg"];
                                    const fileType = value[0].name?.split(".")[1];

                                    if (!fileTypes.includes(fileType)) {
                                      // // return `please upload a valid file format. (${fileTypes})`;
                                    }

                                    const sizes = await getDimension(value[0]);
                                    if (sizes.width !== 1296 && sizes.height !== 396) {
                                      // // return "Image width and height must be 1296px and 396px";
                                    }

                                    // const fileSize = Math.round(value[0].size / 1024);
                                    // if (fileSize > 500) {
                                    //   // return "file size must be lower than 500kb";
                                    // }
                                  }
                                }
                              })}
                              accept=".jpg, .jpeg, .png"
                            />
                          </Form.Group>
                          {errors.heading_image && (
                            <span className="text-danger">
                              {errors.banner_image?.message}
                            </span>
                          )}
                        </Col>
                      </Row>

                    </div>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">CTA Image</Form.Label>
                      {/* <Row className="justify-content-center"> */}
                      <Col sm={9}>
                        {typeof getValues("banner_image") == "string" ? (
                          <div className="image-preview-container">
                            <img
                              src={IMG_URL + getValues("banner_image")}
                              alt="Preview"
                              className="image-preview"
                              style={{ width: "324px", height: "99px" }}
                            />
                          </div>
                        ) : (
                          imageFile2 &&
                          imageFile2?.length > 0 && (
                            <div className="image-preview-container">
                              <img
                                // src={URL.createObjectURL(getValues("image")[0])}
                                src={URL?.createObjectURL(imageFile2[0])}
                                alt="Preview"
                                className="image-preview"
                                style={{ width: "324px", height: "99px" }}
                              />
                            </div>
                          )
                        )}
                      </Col>
                      {/* </Row> */}
                    </div>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">Alt CTA</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={9}>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.alt_cta,
                              })}
                              type="text"
                              {...register("alt_cta", {
                                // required: "Alt CTA is required",
                              })}
                              placeholder="Alt CTA"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  </Col>







                  <Col lg={12}>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">Conclusion</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={12}>
                          <JoditEditor
                            value={conclusionValue}
                            onChange={(value) => setValue("conclusion", value)}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>



                  <Col lg={12}>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">Details</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={12}>
                          <JoditEditor
                            value={detailsValue}
                            onChange={(value) => setValue("details", value)}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">Meta Title</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={12}>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.meta_title,
                              })}
                              type="text"
                              as="textarea"
                              rows={3}
                              {...register("meta_title", {
                                required: "Meta Title is required",
                              })}
                              placeholder="Meta Title"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">Meta Description</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={12}>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.meta_description,
                              })}
                              type="text"
                              as="textarea"
                              rows={3}
                              {...register("meta_description", {
                                required: "Meta Description is required",
                              })}
                              placeholder="Meta Description"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">Keywords</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={12}>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.keyword,
                              })}
                              type="text"
                              as="textarea"
                              rows={3}
                              {...register("keyword", {
                                required: "Keywords is required",
                              })}
                              placeholder="Keywords"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">Schema</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={12}>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.schema,
                              })}
                              type="text"
                              as="textarea"
                              rows={3}
                              {...register("schema", {
                                required: "Schema is required",
                              })}
                              placeholder="Schema"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">OG Title</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={12}>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.og_title,
                              })}
                              type="text"
                              as="textarea"
                              rows={3}
                              {...register("og_title", {
                                required: "OG Title is required",
                              })}
                              placeholder="OG Title"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">OG Description</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={12}>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.og_description,
                              })}
                              type="text"
                              as="textarea"
                              rows={3}
                              {...register("og_description", {
                                required: "OG Description is required",
                              })}
                              placeholder="OG Description"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">Twitter Title</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={12}>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.twitter_title,
                              })}
                              type="text"
                              as="textarea"
                              rows={3}
                              {...register("twitter_title", {
                                required: "Twitter Title is required",
                              })}
                              placeholder="Twitter Title"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="main-form-section mt-3">
                      <Form.Label className="text-center">Twitter Description</Form.Label>
                      <Row className="justify-content-center">
                        <Col sm={12}>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.twitter_description,
                              })}
                              type="text"
                              as="textarea"
                              rows={3}
                              {...register("twitter_description", {
                                required: "Twitter Description is required",
                              })}
                              placeholder="Twitter Description"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  </Col>

                </Row>


                {/* Buttons */}
                <Row className="justify-content-center mt-5 pb-3">
                  <Col sm={6} className="d-flex justify-content-center">
                    <Link to="/masters/ed-tech/blog/blogs">
                      <CancelButton name={"Cancel"} />
                    </Link>
                    <SaveButton
                      name={"Save"}
                      handleSubmit={handleSubmit(onSubmit)}
                    />
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </section>
      </div>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
